import Csrf from "../auth/pwa/Csrf.js";
import Base from "./base.js";

Csrf.getCookie().then((Base.defaults.withCredentials = true));

export default Base;
